export default __webpack_public_path__ + "static/media/wifi.be099a40.svg";